<div class="date-wise-wrapper">
    <div class="" [ngClass]="( config[0].config.visibility.visible ||dateEditable ) ? 'header-section mb-16' : ''  "  [ngStyle]="(!expandView)?{'margin-bottom':'0px','padding':'0px','border-bottom':'none'}:{}">
     <!--      <div class="form-control date-column">
          <div class="header-label">Date(s)</div>
          <ng-container *ngIf="dateEditActive">
             <app-date-picker [formControl]="formDetails.get('dates')" [config]="dateConfig" (changeCallback)="onDateChange($event)"></app-date-picker>
          </ng-container>
          <ng-container *ngIf="!dateEditActive">
             {{formDetails.get('dates').value | dateFormatter}}
          </ng-container>
          <app-button
            *ngIf="!dateEditActive && dateEditable"
            (clickCallback)="toggleDateEdit()"
            prefixIconSrc="assets/edit.svg"
            type="icon"
          ></app-button>
       </div> -->
       <div  class="form-control mr-8" >
         <ng-container *ngIf="dateEditable">
           <span class="mr-4 date-label">Date: </span>
            <span class="font-weight-700">{{formDetails.get('dates').value[0][0].format("DD/MM/YYYY")}}</span>
         </ng-container>
      </div>

       <ng-container *ngFor="let field of config">
          <ng-container [ngSwitch]="field.elementKey">
             <div *ngSwitchCase="'CabCount'" class="form-control cabs-column">
                <!-- <div class="">{{field.config.displayName}}</div> -->
                <div *ngIf="field.config.visibility.visible">
                   <app-field-generator
                    [config]="field.config"
                    [inputControl]="formDetails.get('CabCount')" >
                   </app-field-generator>
                </div>
             </div>
             <div *ngSwitchCase="'CabToggle'" class="form-control cab-toggle-column">
                <ng-container *ngIf="formDetails.get('CabCount').value > 1">
                  <span class="mr-10 cab-toggle-label">{{field.config.displayName}}</span>
                   <app-toggle-button
                    type="light"
                    [formControl]="formDetails.get('CabToggle')" >
                   </app-toggle-button>
                </ng-container>
             </div>
          </ng-container>
       </ng-container>

       <app-button (clickCallback)="showDeleteWarning()" *ngIf="dateEditable"
       [prefixIconSrc]="'assets/delete.svg'"
       type="textOnly"  matTooltip="Delete Booking" matTooltipClass="booking-table-tooltip"  style="float: right; margin-right:16px"></app-button>
       
       <app-button (clickCallback)="toggleBooking()" *ngIf="dateEditable"
       [prefixIconSrc]="expandView ?'assets/Collapse.svg':'assets/Expand.svg' "
       type="textOnly"  matTooltip="View Details" matTooltipClass="booking-table-tooltip"  style="float: right;"></app-button>
      
      
     <!--   <div class="controls-column">
          <app-button
               !  [prefixIconSrc]="toggleBooking ? 'assets/Expand.svg':'assets/Collapse.svg' "
             *ngIf="!this.createBookingService.isEditMode"
             class="mr-10"
             (clickCallback)="showDeleteWarning()"
             prefixIconSrc="assets/close-circle.svg"
             type="icon"
             ></app-button>
          <app-button
            (clickCallback)="toggleView()"
            [prefixIconSrc]="isFormVisible ? 'assets/caret-up-circle-filled.svg' : 'assets/caret-down-circle-filled.svg'"
            type="icon"
          ></app-button>
       </div> -->
    </div>
    <div *ngIf="isFormVisible" [ngStyle]="!expandView?{'display':'none'}:{}">
       <div class="tab-wrapper" *ngIf="!formDetails.get('CabToggle').value">
          <app-stepper class="stepper" [formArray]="formDetails.get('cabs')" [activeStep]="activeCab" [steps]="cabTabs" (stepChangeCallback)="onTabChange($event)" [hideStepNumber]="true" [centerText]="true" [activeBlue]="true" [line]="false" [openForm]="'date-wise'" ></app-stepper>
       </div>
       <div>
         <ng-container *ngFor="let cab of formDetails.get('cabs').controls; index as index">
            <app-cab-form
              *ngIf="index == activeCab"
              [config]="cabConfig"
              [userDetails]="userDetails"
              [dateControl]="formDetails.get('dates')"
              [formDetails]="formDetails.get('cabs').at(index)"
              [bookingEditConfig]="bookingEditConfig"
              [referenceBooking]="referenceBooking"
              [dateEditable]="dateEditable"
              [miscellConfig]="miscellConfig"
              [workflowConfig]="workflowConfig"
              [configComplete]="configComplete"
              [designationConfig]="designationConfig"
            ></app-cab-form>
         </ng-container>
       </div>
      
       <app-dialog
       *ngIf="isDuplicateDateError"
       titleText="Error"
       type="Alert"
       [buttonText]="['Ok']"
       (approveCallback)="toggleDuplicateDateError()"
      >
       The same date cannot be selected twice in a request
      </app-dialog>
    </div>
    <app-dialog
        *ngIf="isCabMergeWarning"
        titleText="Confirm"
        type="confirm"
        [buttonText]="['Yes', 'No']"
        (approveCallback)="onCabMergeApprove()"
        (dismissCallback)="onCabMergeCancel()"
        (closeCallback)="onCabMergeCancel()"
       >
       The details entered for Booking 1 will be applied to all. Do you wish to continue?
       </app-dialog>
       <app-dialog
        *ngIf="isDateCardDeleteWarning"
        titleText="Confirm"
        type="confirm"
        [buttonText]="['Yes', 'No']"
        (approveCallback)="deleteCard()"
        (dismissCallback)="hideDeleteWarning()"
        (closeCallback)="hideDeleteWarning()"
       >
       The details entered for {{formDetails.get('dates').value[0][0].format("DD/MM/YYYY")}} will be deleted.
       Do you wish to continue?
       </app-dialog>
       <div class="apply-same-btn fs-12"  *ngIf="index==0 && dateEditable && expandView">
         <button mis-button type="none" size="sm" class="add-stop apply-detail-btn" (click)="applySameDetails.emit()">
            Apply details to all selected dates
          </button>
       </div>
 </div>
